module.exports = __webpack_public_path__ + "static/media/355678931_649881907014029_485565836281153361_n.aa76e675.jpg";